import React from "react";
import Banner from "../components/Banner";
import MovieList from "../components/MovieList";

const Home = () => {
  return (
    <div>
      <Banner />
      <MovieList />
    </div>
  );
};

export default Home;
